<template>
  <div class="select-picker">
    <van-popup
      v-model="visible"
      position="bottom"
      :style="{ height: 'calc(50vh)' }"
    >
      <div class="select-box">
        <van-cell v-for="(item, index) in data" clickable :key="index">
          <div>
            <div style="font-weight: bold;">
              账项： {{ item.AccountItemName }}
            </div>
            <div class="desc">{{ item.OutDetail }} -> {{ item.InDetail }}</div>
            <div class="desc">
              <span>操作人: {{ item.操作人 }}</span>
              <span> {{ item.CreationTime }}</span>
            </div>
          </div>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import orderApi from "@/api/order.js";

import { Popup, Picker, Cell, CellGroup, Icon, Search, Button } from "vant";
import moment from "moment";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Button.name]: Button,
  },
  props: {
    height: {
      type: String,
      default: "100%",
    },
    change: { type: Function },
    clear: { type: Function },
  },
  data() {
    return { moment, visible: false, data: [], recordId: "" };
  },
  created: function() {},
  mounted() {},

  methods: {
    onShow(id) {
      this.visible = true;
      this.recordId = id;
      orderApi.GetTransferRecords({ Id: this.recordId }).then(res => {
        this.data = res.Data;
      });
    },
    onCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.select-box {
  position: relative;
  height: 50vh;
}
.desc {
  color: #666;
  font-size: 12px;
}
</style>
